//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from "vuex";
import AuthService from "@/services/AuthService";
import AppHeader from "./components/header";
import logger from "@/utils/logger";

export default {
  name: "LayoutDefault",

  computed: {
    ...mapState("main", ["user", "appVersion"]),
  },

  components: { AppHeader: AppHeader },

  watch: {
    $route: {
      immediate: true,
      handler(to) {
        document.title = !to.meta.title ? "Avare" : "Avare " + to.meta.title;
      },
    },
  },

  data() {
    return {
      title: "Avare",
      isLoggedIn: false,
      companyDataLoaded: false,
      auth: null,
    };
  },

  created: function() {    
    this.initAuthServiceAndUser();
  },

  methods: {
    async initAuthServiceAndUser() {
      this.auth = await AuthService.create();

      var user = await this.auth.getUser();
      if (user == null || user.expired) {
        logger.log("Not logged in");
        this.isLoggedIn = false;
        return;
      }
      this.isLoggedIn = true;
      var company;
      try {
        company = await this.getCompany();
      } catch {
        this.isLoggedIn = false;
        this.auth.logout();
        logger.log("Failed to get company, probably deactivated");
      }

      if (company) {    
        
        this.setUser(user);      
    

        this.repeatSilentRenew();

        Promise.allSettled([
          this.getSettings(),
          this.getVatType(),          
          this.getProject(),
          this.getDepartment(),
          this.getLocation(),
          this.getWarehouse(),
          this.getCurrencies(),
          this.getSuppliers(),
          this.getDimensions(),
          this.getDimensionSettings(),
        ]).then((result) => {
          // eslint-disable-next-line no-unused-vars
          const k = result;
          this.companyDataLoaded = true;
        });
      } else {
        this.isLoggedIn = false;
        this.auth.logout();
        logger.log("Failed to get company, probably deactivated");
      }
    },

    login() {
      this.auth.login();
    },

    // check every minute if the token will expire in less than 10 minutes. if true, renew the token.
    async repeatSilentRenew() {
      var user = await this.auth.getUser();
      if (user) {
        var now = Math.floor(Date.now() / 1000);
        
        logger.log(`token expires in ${user.expires_at - now} seconds`);
        

        if (user.expires_at - now < 600) {
          logger.log("renewing...");   
          logger.log("Old:" + user.access_token);   
          await this.auth.silentRenew();
          user = await this.auth.getUser();
          logger.log("New:" + user.access_token);   
          this.setUser(user); 
        }

        setTimeout(this.repeatSilentRenew, 60000);
      }
    },

    ...mapActions("main", [
      "getVatType",
      "getAccount",
      "getProject",
      "getDepartment",
      "getDimensions",
      "getDimensionSettings",
      "getSettings",
      "getLocation",
      "getWarehouse",
      "getCurrencies",
      "getSuppliers",
      "getCompany",
      "setUser",
    ]),
  },
};
